<template>
  <div>
    <slot />
  </div>
</template>

<script>
  import memoize from 'lodash-es/memoize';

  const getObserver = memoize(
    (options) =>
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.$_gl_intersectionHandler(entry);
        });
      }, options || {}),
  );

  export default {
    name: 'IntersectionObserver',
    props: {
      options: {
        type: Object,
        required: false,
        default: null,
      },

      once: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['update', 'appear', 'disappear'],

    mounted() {
      const observer = getObserver(this.options);

      this.$el.$_gl_intersectionHandler = (entry) => {
        this.$emit('update', entry);

        if (entry.isIntersecting) {
          this.$emit('appear', this.$attrs);

          if (this.once && entry.intersectionRatio > 0) {
            observer.unobserve(this.$el);
          }
        } else {
          this.$emit('disappear');
        }
      };

      this.$el.$_gl_intersectionObserver = observer;

      observer.observe(this.$el);
    },

    unmounted() {
      this.$el.$_gl_intersectionObserver.unobserve(this.$el);
      delete this.$el.$_gl_intersectionHandler;
      delete this.$el.$_gl_intersectionObserver;
    },

    // Expose getObserver method for tests
    getObserver,
  };
</script>
